import { lazy } from 'react';

const StaffRosterModal = lazy(() =>
  import('./pages/StaffRosters/components/StaffRosterModal'),
);

const StudentTagModal = lazy(() =>
  import('./pages/StudentTags/components/StudentTagModal'),
);

export default {
  STAFF_ROSTER_MANAGEMENT_MODAL: StaffRosterModal,
  STUDENT_TAG_MANAGEMENT_MODAL: StudentTagModal,
};
